/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import classnames from 'classnames';
import ModeDeliveryTableFragment from './component/ModelDeliveryFragment';

import {
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Collapse,
} from 'reactstrap';

import 'react-datepicker/dist/react-datepicker.css';
import 'flatpickr/dist/themes/material_blue.css';
import 'flatpickr/dist/plugins/monthSelect/style.css';
import { incoTermTable } from '../../common/data';
import metaMask from '../../assets/images/nft/notifalert.png';
import { isNumericOnly } from '../../utils/validators';
import axios from 'axios';
import { api } from '../../config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { format } from 'date-fns';
import { convertToDisplayDateFormatddmmmyyyy } from '../../utils/dateformatter';
import logger from '../../utils/logger';
import {
  convertToInputDateFormat,
  convertToDisplayDateFormat,
  formatDateToDDMMYYYY,
  convertDisplayddMMyyyy,
  formatDateToddmmyyhhmm,
} from '../../utils/dateformatter';
import { formatNumber, formatNumberUS } from '../../utils/numberformatter';
import {
  PricingPeriodData,
  IncotermPortTypeData,
} from '../../constants/masterData';
import DeliveryVesselFirstLocation from './component/DeliveryVesselFirstLocation';
import DeliveryVesselFirstLocationNotes from './component/DeliveryVesselFirstLocationNotes.js';
import {
  BtnBold,
  BtnItalic,
  Editor,
  EditorProvider,
  Toolbar,
  BtnBulletList,
  BtnClearFormatting,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  Separator,
} from 'react-simple-wysiwyg';
import IncotermTableFragment from './component/IncotermTableFragment';
import QuantityTableFragment from './component/QuantityTableFragment';
import '../../App.css';
import './HpsView.css';
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const MandatoryBadge = () => (
  <span className='badge bg-danger-subtle text-danger border border-danger-subtle rounded-pill fw-medium fs-11'>
    Mandatory
  </span>
);

const HtmlContent = ({ value, framed = true }) => {
  if (!value) {
    return <p className='text-dark mb-0 lh-base'>-</p>;
  }

  const body = (
    <div
      className='html-content-body'
      dangerouslySetInnerHTML={{ __html: value }}
    />
  );

  if (!framed) return body;

  return <div className='html-content-panel'>{body}</div>;
};

const ClauseBlock = ({ index, title, value, isMandatory }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className={`rounded-3 overflow-hidden mb-2 ${
        isExpanded
          ? 'border border-primary shadow-sm bg-white'
          : 'border bg-white'
      }`}
    >
      <button
        type='button'
        className='w-100 border-0 bg-transparent text-start px-3 py-3 d-flex align-items-center gap-3'
        onClick={() => setIsExpanded(prev => !prev)}
        aria-expanded={isExpanded}
      >
        <span
          className={`rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 fw-semibold fs-12 ${
            isExpanded ? 'bg-primary text-white' : 'bg-light text-muted border'
          }`}
          style={{ width: '28px', height: '28px' }}
        >
          {index}
        </span>

        <div className='flex-grow-1 min-w-0'>
          <div className='d-flex align-items-center gap-2 flex-wrap'>
            <span
              className={`fs-14 mb-0 ${
                isExpanded ? 'fw-bold text-dark' : 'fw-semibold text-dark'
              }`}
            >
              {title}
            </span>
            {isMandatory && <MandatoryBadge />}
          </div>
          {!isExpanded && (
            <span className='text-muted fs-12'>
              Click to view clause content
            </span>
          )}
        </div>

        <span
          className={`rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 ${
            isExpanded
              ? 'bg-primary-subtle text-primary'
              : 'bg-light text-muted'
          }`}
          style={{ width: '28px', height: '28px' }}
        >
          <i
            className={`ri-arrow-${isExpanded ? 'up' : 'down'}-s-line fs-16`}
          ></i>
        </span>
      </button>

      <Collapse isOpen={isExpanded}>
        <div className='px-3 pb-3'>
          <div className='ms-1 ps-4'>
            {isMandatory && (
              <div className='text-danger small fw-medium mb-2'>
                * Mandatory clause for DMUT to fulfill
              </div>
            )}
            <div className='p-3 rounded-3 bg-light-subtle border text-muted fs-13 lh-base'>
              <HtmlContent value={value} framed={false} />
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

const displayValue = value => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

const InfoBlock = ({ label, value, col = 3, isHtml = false }) => (
  <Col xs={6} md={col}>
    <div className='mb-2 field-border-brown'>
      <Label className='text-muted'>{label}:</Label>
      {isHtml ? (
        <HtmlContent value={value} />
      ) : (
        <p className='text-dark fs-13 mb-0 lh-base'>{displayValue(value)}</p>
      )}
    </div>
  </Col>
);

const formatProposalDeadline = isoDate =>
  isoDate ? formatDateToddmmyyhhmm(isoDate) : '-';

const getContractTypeLabel = contractType => {
  const value = parseInt(contractType, 10);
  if (value === 1) return 'TERM';
  if (value === 2) return 'SPOT';
  return '-';
};

const isSpotContract = procurement =>
  parseInt(procurement?.contractType, 10) === 2;

const formatPeriodMonth = isoDate => {
  if (!isoDate) return '-';
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('en-GB', {
    month: 'short',
    year: 'numeric',
  }).format(date);
};

const getContractPeriodProps = procurement => {
  if (!procurement) {
    return {
      isSpot: false,
      startLabel: 'Start Period',
      startValue: '-',
      endLabel: 'End Period',
      endValue: '-',
    };
  }

  if (isSpotContract(procurement)) {
    return {
      isSpot: true,
      startLabel: 'Period',
      startValue: formatPeriodMonth(
        procurement.contractPeriodSpot || procurement.contractPeriodTermStart
      ),
      endLabel: null,
      endValue: null,
    };
  }

  return {
    isSpot: false,
    startLabel: 'Start Period',
    startValue: formatPeriodMonth(procurement.contractPeriodTermStart),
    endLabel: 'End Period',
    endValue: formatPeriodMonth(procurement.contractPeriodTermEnd),
  };
};

const RequirementTab = ({
  ids,
  form,
  _setForm,
  dataCause,
  handleSaveDraftProc,
  validatedeliveryModal,
  errors,
  error,
  setError,
  setErrors,
  setIsLoading,
  isLoading,
  qtyDeliveryData,
  token,
}) => {
  const quantityRefs = useRef();
  const [isendDate, setIsEndDate] = useState(false);
  const [expandedClauses, setExpandedClauses] = useState({});
  const toggleClauseCard = id => {
    setExpandedClauses(prev => ({ ...prev, [id]: !prev[id] }));
  };
  const [unitSizeType, setUnitSizeType] = useState('');
  const [deletemodal, setDeleteModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalincoterm, setModalIncoterm] = useState(false);
  const [modalquantity, setModalQuantity] = useState(false);
  const [modalloadingdischarge, setModalLoadingDischarge] = useState(false);
  const [modalquantityincoterm, setModalQuantityIncoterm] = useState(false);
  const [productName, setProductName] = useState({ items: [] });
  const [productTypeData, setProductTypeData] = useState({ items: [] });
  const [currencyName, setCurrencyName] = useState({});
  const [ratioData, setRatioData] = useState({ items: [] });
  const [invoiceQuantityData, setInvoiceQuantityData] = useState({ items: [] });
  const [portRestrictionModal, setPortRestrictionModal] = useState(false);
  const [selectedPort, setSelectedPort] = useState(null);
  const [modelinvoiceQuantityData, setModelInvoiceQuantityData] = useState({
    items: [],
  });
  const [qtyDeliveryDataQuantity, setQtyDeliveryDataQuantity] = useState({
    items: [],
  });
  const [IncotermRouteData, setIncotermRouteData] = useState({ items: [] });
  const [IncotermLocationData, setIncoTermLocationData] = useState({
    items: [],
  });
  const [lawData, setLawData] = useState({ items: [] });
  const [abitrationData, setAbitrationData] = useState({ items: [] });
  const [dataindexprice, setDataIndexPrice] = useState({ items: [] });
  const [incotermtype, setIncotremType] = useState({ items: [] });
  const [qtyDeliveryDataIncoterm, setQtyDeliveryDataIncoterm] = useState({
    items: [],
  });
  const [butanesection, setButaneSection] = useState(false);
  const [propanesection, setPropaneSection] = useState(false);
  const [comptitle, setCompTile] = useState('');
  const [comptitlesec, setCompTileSec] = useState('');
  const [activeTab, setactiveTab] = useState('1');
  const toggles = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };
  const editorRef = useRef(null);

  const [activeTabs, setActiveTabs] = useState({});
  const toggle = (id, tab) => {
    setActiveTabs(prev => ({
      ...prev,
      [id]: tab,
    }));
  };

  const handleTextChangeDelivery = field => event => {
    setDeliveryFormData({
      ...deliveryformData,
      [field]: event.target.value,
    });
  };

  const handleDeliveryTextChange = e => {
    const { name, value } = e.target;
    setDeliveryFormData({ ...deliveryformData, [name]: value });
  };

  const handleDeliveryCheckBoxChange = e => {
    const { name, checked } = e.target;
    setDeliveryFormData({
      ...deliveryformData,
      [name]: checked ? 1 : 0,
    });
  };

  const handleDeliveryDateChange = e => {
    const { name, value } = e.target;
    setDeliveryFormData({
      ...deliveryformData,
      [name]: convertToDisplayDateFormat(value),
    });
  };

  const handleDeliverySelectChange = selectedOption => {
    setDeliveryFormData({
      ...deliveryformData,
      ratioLpgId: selectedOption.value,
    });
  };

  const validatequantityanddelivery = () => {
    let tempErrors = {};
    if (!deliveryformData.deliveryUnit?.trim()) {
      tempErrors.deliveryUnit = 'Please enter Delivery Unit';
    }

    if (!deliveryformData.frequency?.trim()) {
      tempErrors.frequency = 'Please enter Freq.';
    }

    if (form.productNameId === '4588b5e6-7309-49d0-9107-59cbb96b6bd8') {
      if (!deliveryformData.ratioLpgId) {
        tempErrors.ratioLpgId = 'Please Select Ratio';
      }
    }

    if (!deliveryformData.indexPriceId) {
      tempErrors.indexPriceId = 'Please Select ';
    }

    if (!deliveryformData.pricingPeriod) {
      tempErrors.pricingPeriod = 'Please Select ';
    }

    if (!deliveryformData.otherIndexPriceId) {
      tempErrors.otherIndexPriceId = 'Please Select ';
    }

    if (Object.keys(tempErrors).length !== 0) {
      toast.error('Warning ! Please Check Mandatory Fields..', {
        position: 'top-right',
        hideProgressBar: false,
        closeOnClick: false,
        className: 'bg-warning  text-black',
      });
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const toggledeletemodal = () => {
    setDeleteModal(!deletemodal);
  };

  const deliverymodal = () => {
    if (validatedeliveryModal()) {
      setModal(!modal);
    }
  };

  const togglemodalincoterm = () => {
    setModalIncoterm(!modalincoterm);
  };

  const quantitymodal = () => {
    setModalQuantity(!modalquantity);
  };

  const loadingdischrgemodal = () => {
    setModalLoadingDischarge(!modalloadingdischarge);
  };

  const togglemodalquantity = () => {
    setModalQuantity(!modalquantity);
  };

  const toggleloadingdischrge = () => {
    setModalLoadingDischarge(!modalloadingdischarge);
  };

  const handleAddDataDelivery = async () => {
    if (validatequantityanddelivery()) {
      try {
        setIsLoading(true);

        const response = await axios.post(
          `${api.API_URL}/quantity-delivery`,
          selectedFieldsDeliveryFormData,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        fetchDeliveryDataDetail(response.id);
      } catch (error) {
        toast.error(`Failed to save data: ${error.message}`);
        setError(error.message);
      } finally {
        setIsLoading(false);
        handleSaveDraftProc(); // tetap jalan
        LoadDefault();
      }
    }
  };

  const handleUpdDataDelivery = async () => {
    try {
      setIsLoading(true);

      await axios.put(
        `${api.API_URL}/quantity-delivery/${deliveryformData.id}`,
        selectedFieldsDeliveryFormData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data Has been Updated`);

      fetchDeliveryDataDetail(deliveryformData.id);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      handleSaveDraftProc();
      LoadDefault();
    }
  };

  useEffect(() => {
    quantityRefs.current = qtyDeliveryData.items.map(() => React.createRef());
  }, [qtyDeliveryData.items]);

  useEffect(() => {
    if (form.productTypeId) {
      CompositionVar(form.productTypeId);
    }
  }, [form.productTypeId]);

  const LoadDefault = async () => {
    try {
      await Promise.all([
        fetchProductName(),
        fetchInvoiceQuantity(),
        fetchIncotermRoute(),
        fetchIncotermLocation(),
        fetchIncotermType(),
      ]);
      setDeliveryFormData(prev => ({
        ...prev,
        procurementId: form.id,
      }));
    } catch (error) {
      logger.error('LoadDefault error:', error);
    }
  };

  const fetchProductName = useCallback(async () => {
    try {
      const response = await fetch(`${api.API_URL}/product`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setProductName({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  }, [token]);

  const fetchInvoiceQuantity = useCallback(async () => {
    try {
      const response = await fetch(`${api.API_URL}/invoicing-quantity`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setInvoiceQuantityData({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  }, [token]);

  const fetchCurrencyName = useCallback(async () => {
    try {
      const response = await fetch(`${api.API_URL}/paymentcurrency`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.currencyName,
      }));
      setCurrencyName({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  }, [token]);

  const fetchLaw = useCallback(async () => {
    try {
      const response = await fetch(`${api.API_URL}/law`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setLawData({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  }, [token]);

  const fetchAbitration = useCallback(async () => {
    try {
      const response = await fetch(`${api.API_URL}/law/getAll-arbitration`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setAbitrationData({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  }, [token]);

  const fetchModeInvoiceQuantity = useCallback(
    async invoicingQuantityId => {
      try {
        const response = await fetch(
          `${api.API_URL}/invoicing-quantity/getAll-ModeInvoicingQuantity?InvoicingQuantityId=${invoicingQuantityId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();
        const items = result.data.items.map(item => ({
          value: item.id,
          label: item.name,
        }));
        setModelInvoiceQuantityData({ items });
      } catch (error) {
        logger.error('Error:', error);
      }
    },
    [token]
  );

  const fetchProductType = useCallback(
    async productTypeId => {
      try {
        const response = await fetch(
          `${api.API_URL}/product/getAll-product-type?ProductId=${productTypeId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();
        const items = result.data.items.map(item => ({
          value: item.id,
          label: item.name,
        }));
        setProductTypeData({ items });
      } catch (error) {
        logger.error('Error:', error);
      }
    },
    [token]
  );

  const handleSelectChangeDelivery = (e, field) => {
    setDeliveryFormData({
      ...deliveryformData,
      [field]: e ? e.value : '',
    });
  };

  const CompositionVar = action => {
    //let comptitle = "";
    switch (action) {
      case '4588b5e6-7309-49d0-9107-59cbb96b6b11':
        setCompTileSec('Refrigerated Propane');
        setPropaneSection(true);
        setButaneSection(false);
        break;
      case '4588b5e6-7309-49d0-9107-59cbb96b6b12':
        setCompTile('Refrigerated Butane');
        setButaneSection(true);
        setPropaneSection(false);
        break;

      case '4588b5e6-7309-49d0-9107-59cbb96b6b13':
        setCompTile('LPG Mixed Pressurized');
        setButaneSection(true);
        setPropaneSection(false);
        break;

      case '4588b5e6-7309-49d0-9107-59cbb96b6b19':
        setCompTile('Pressurized Butane');
        setCompTileSec('Pressurized Propane');
        setButaneSection(true);
        setPropaneSection(true);
        break;
      case '4588b5e6-7309-49d0-9107-59cbb96b6b18':
        setCompTile('Refrigrate Butane');
        setCompTileSec('Refrigrate Propane');
        setButaneSection(true);
        setPropaneSection(true);
        break;
      case '4588b5e6-7309-49d0-9107-59cbb96b6b15':
        setCompTile('Pressurized Butane');
        setButaneSection(true);
        setPropaneSection(false);
        break;
      case '4588b5e6-7309-49d0-9107-59cbb96b6b14':
        setCompTileSec('Pressurized Propane');
        setPropaneSection(true);
        setButaneSection(false);
        break;
      //comptitle = "None";
    }
    //setCompTile(comptitle);
  };

  const [deliveryformData, setDeliveryFormData] = useState({
    procurementId: null,
    procurement: null,
    deliveryUnit: null,
    frequency: null,
    ratioLpgId: null,
    ratioLpg: null,
    pricingPeriod: null,
    indexPriceId: null,
    indexPrice: null,
    otherIndexPriceId: null,
    otherIndexPrice: null,
    isCorrelationBetweenTwoIndex: null,
    startDatePublishIndex: null,
    endDatePublishIndex: null,
    schemaBL: null,
    notesForPricing: null,
    id: null,
  });

  const fetchDeliveryDataDetail = async deliveryid => {
    try {
      const response = await axios.get(
        `${api.API_URL}/quantity-delivery/${deliveryid}`,
        {
          withXSRFToken: true,
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: `application/json`,
          },
        }
      );
      const data = response;
      setDeliveryFormData({
        procurementId: data.procurementId || null,
        procurement: data.procurement || null,
        deliveryUnit: data.deliveryUnit || null,
        frequency: data.frequency || null,
        ratioLpgId: data.ratioLpgId || null,
        ratioLpg: data.ratioLpg || null,
        pricingPeriod: data.pricingPeriod || null,
        indexPriceId: data.indexPriceId || null,
        indexPrice: data.indexPrice || null,
        otherIndexPriceId: data.otherIndexPriceId || null,
        otherIndexPrice: data.otherIndexPrice || null,
        isCorrelationBetweenTwoIndex: data.isCorrelationBetweenTwoIndex || null,
        startDatePublishIndex:
          format(data.startDatePublishIndex, 'dd/MM/yyyy') || null,
        endDatePublishIndex:
          format(data.endDatePublishIndex, 'dd/MM/yyyy') || null,
        schemaBL: data.schemaBL || null,
        notesForPricing: data.notesForPricing || null,
        id: data.id || null,
      });
    } catch (error) {
      logger.error('Error fetching data from Invoice API:', error);
    }
  };

  const selectedFieldsDeliveryFormData = {
    procurementId: form.id,
    ratioLpgId: deliveryformData.ratioLpgId,
    deliveryUnit: deliveryformData.deliveryUnit,
    frequency: deliveryformData.frequency,
    pricingPeriod: deliveryformData?.pricingPeriod ?? 1,
    indexPriceId: deliveryformData.indexPriceId,
    otherIndexPriceId: deliveryformData.otherIndexPriceId,
    isCorrelationBetweenTwoIndex: deliveryformData.isCorrelationBetweenTwoIndex,
    startDatePublishIndex: deliveryformData?.startDatePublishIndex
      ? convertToInputDateFormat(deliveryformData.startDatePublishIndex)
      : null,
    endDatePublishIndex: convertToInputDateFormat(
      deliveryformData.endDatePublishIndex
    ),
    schemaBL: deliveryformData.schemaBL,
    notesForPricing: deliveryformData.notesForPricing,
  };

  const handleDeleteQtyDeliveryDetail = (id = null, _section = null) => {
    Swal.fire({
      title: `Are You sure want to Delete this Record?`,
      text: 'Deleted Data cannot be Recovered!!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, Delete!',
      cancelButtonText: 'Cancel',
    }).then(result => {
      if (result.isConfirmed) {
        // onDelete(); // Panggil props atau function untuk hapus data
        handleDelDataDeliveryQuantity(id);
        //Swal.fire("Deleted!", "Data was successfully deleted.", "success");
      }
    });
  };

  const handleDeleteIncotermDeliveryDetail = (
    id = null,
    _deliveryid = null,
    _section = null
  ) => {
    Swal.fire({
      title: `Are You sure want to Delete this Record?`,
      text: 'Deleted Data cannot be Recovered!!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, Delete!',
      cancelButtonText: 'Cancel',
    }).then(result => {
      if (result.isConfirmed) {
        // onDelete(); // Panggil props atau function untuk hapus data
        handleDelDataDeliveryIncotermDetail(id);

        //Swal.fire("Deleted!", "Data was successfully deleted.", "success");
      }
    });
  };

  useEffect(() => {
    const newTabs = {};
    qtyDeliveryData.items.forEach(item => {
      newTabs[item.id] = `${item.id}1`;
    });
    setActiveTabs(newTabs);
  }, [qtyDeliveryData.items]);

  ///------- Quantity delivery

  const [deliveryquantityformData, setDeliveryQuantityFormData] = useState({
    quantityDeliveryTermId: null,
    quantity: null,
    quantityLocation1: null,
    quantityLocation2: null,
    id: null,
  });

  const handleDeliveryQuantityOpenModalNew = (_deliveryid = null) => {
    setDeliveryQuantityFormData({
      quantityDeliveryTermId: null,
      quantity: null,
      quantityLocation1: null,
      quantityLocation2: null,
      id: null,
    });
    quantitymodal();
  };

  const handleDeliveryQuantityOpenModalUpd = (deliveryqtyid = null) => {
    fetchDeliveryDataDetailSelectOneQuantity(deliveryqtyid);
    quantitymodal();
  };

  const handleLoadingDischargeOpenModalUpd = async (
    id = null,
    _deliveryid = null,
    _section = null
  ) => {
    await fetchDataDeliveryIncoterm(id);
    //fetchDeliveryDataDetailSelectOneQuantity(deliveryqtyid);
    loadingdischrgemodal();
  };

  const selectedFieldsDeliveryQuantityFormData = {
    quantityDeliveryTermId: deliveryformData.id,
    quantity: deliveryquantityformData.quantity,
  };

  const selectedFieldsDeliveryQuantityUpdData = {
    quantityDeliveryTermId: deliveryformData.id,
    quantity: deliveryquantityformData.quantity,
    quantityLocation1: deliveryquantityformData.quantityLocation1,
    quantityLocation2: deliveryquantityformData.quantityLocation2,
  };

  const fetchDeliveryDataDetailQuantity = async deliveryid => {
    try {
      const response = await fetch(
        `${api.API_URL}/quantity-information?QuantityDeliveryTermId=${deliveryid}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      const items = result.data.items.map(item => ({
        quantityDeliveryTermId: item.quantityDeliveryTermId,
        quantity: item.quantity,
        quantityLocation1: item.quantityLocation1,
        quantityLocation2: item.quantityLocation2,
        id: item.id,
      }));
      setQtyDeliveryDataQuantity({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  };

  const fetchDeliveryDataDetailSelectOneQuantity = async deliveryqtyid => {
    try {
      const response = await axios.get(
        `${api.API_URL}/quantity-information/${deliveryqtyid}`,
        {
          withXSRFToken: true,
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: `application/json`,
          },
        }
      );
      const data = response;
      setDeliveryQuantityFormData({
        quantityDeliveryTermId: data.quantityDeliveryTermId,
        quantity: data.quantity,
        quantityLocation1: data.quantityLocation1,
        quantityLocation2: data.quantityLocation2,
        id: deliveryqtyid,
      });
    } catch (error) {
      logger.error('Error fetching data from Invoice API:', error);
    }
  };

  const handleUpdDataDeliveryQuantity = async deliveryqtyid => {
    try {
      setIsLoading(true);

      await axios.put(
        `${api.API_URL}/quantity-information/${deliveryqtyid}`,
        selectedFieldsDeliveryQuantityUpdData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data Has been Updated`);
      fetchDeliveryDataDetailQuantity(deliveryformData.id);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      LoadDefault();
    }
  };

  const handleAddDataDeliveryQuantity = async () => {
    try {
      setIsLoading(true);
      await axios.post(
        `${api.API_URL}/quantity-information`,
        selectedFieldsDeliveryQuantityFormData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Quantity Has been Added`);
      fetchDeliveryDataDetailQuantity(deliveryformData.id);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      //handleSaveDraftProc(); // tetap jalan
      LoadDefault();
    }
  };

  const handleDelDataDeliveryQuantity = async id => {
    try {
      setIsLoading(true);
      await axios.delete(`${api.API_URL}/quantity-information/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(`Data has been deleted: ${deliveryformData.id}`);
      fetchDeliveryDataDetailQuantity(deliveryformData.id);
    } catch (error) {
      toast.error(`Failed to delete data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      LoadDefault();
    }
  };

  ///--- Add Incoterm---------------------------------------------------------------

  const handleSelectChangeIncoterm = (e, field) => {
    const value = e ? e.value : '';
    const newData = {
      ...deliveryincotermformData,
      [field]: value,
    };

    if (field === 'incotermId') {
      newData.timelineType =
        value === 'e0173dfd-e109-4054-8640-23d95befd326' ? 'ALD' : 'ADD';
      //fetchIncotermLocation(e.label, null);
      fetchIncotermLocation(null, e.value);
    }

    if (field === 'incotermRouteId') {
      fetchIncotermLocation(null, e.value);
    }

    setDeliveryIncotermFormData(newData);
  };

  const handleDeliveryDateChangeIncoterm = e => {
    const { name, value } = e.target;
    setDeliveryIncotermFormData({
      ...deliveryincotermformData,
      [name]: convertToDisplayDateFormat(value),
    });
  };

  const handleDeliveryNumberChangeIncoterm = fieldName => e => {
    const input = e.target.value;
    if (isNumericOnly(input)) {
      setDeliveryIncotermFormData({
        ...deliveryincotermformData,
        [fieldName]: input === '' ? null : parseInt(input),
      });
    }
  };

  const handleDeliveryTextChangeIncoterm = field => event => {
    setDeliveryIncotermFormData({
      ...deliveryincotermformData,
      [field]: event.target.value,
    });
  };

  const setDeliveryQuantityDefault = () => {
    setDeliveryQuantityFormData({
      quantityDeliveryTermId: null,
      quantity: null,
      quantityLocation1: null,
      quantityLocation2: null,
      id: null,
    });
  };

  const handleDeliveryQtyIncotermOpenModalUpd = (deliveryqtyid = null) => {
    setDeliveryQuantityDefault();
    setDeliveryQuantityFormData({
      quantityDeliveryTermId: null,
      quantity: null,
      quantityLocation1: null,
      quantityLocation2: null,
      id: null,
    });

    fetchDeliveryDataDetailSelectOneQuantity(deliveryqtyid);
    quantityincotermmodal();
  };

  const quantityincotermmodal = () => {
    setModalQuantityIncoterm(!modalquantityincoterm);
  };

  const togglemodalquantityincoterm = () => {
    setModalQuantityIncoterm(!modalquantityincoterm);
  };

  const fetchIncotermRoute = useCallback(async () => {
    try {
      const response = await fetch(
        `${api.API_URL}/incoterm/get-incoterm-route`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setIncotermRouteData({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  }, [token]);

  const fetchIncotermLocation = async (_id = null, routeid = null) => {
    // const strquery =
    //   id === null ? `IncotermRouteId=${routeid}` : `Description=${id}`;

    //const producttype = form.productNameId === "4588b5e6-7309-49d0-9107-59cbb96b6bd8" ? true : null;
    const producttype =
      form.productNameId === '4588b5e6-7309-49d0-9107-59cbb96b6bd8' ??
      'IsLpgCase=true';

    try {
      const response = await fetch(
        `${api.API_URL}/incoterm/get-incoterm-location?IncotermRouteId=${routeid}&${producttype}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setIncoTermLocationData({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  };

  const [deliveryincotermformData, setDeliveryIncotermFormData] = useState({
    quantityDeliveryTermId: null,
    incotermId: null,
    incotermPortType: null,
    incotermRouteId: null,
    incotermLocationId: null,
    incotermLocation2Id: null,
    timelineType: null,
    startDate: null,
    endDate: null,
    timelineType2: null,
    startDate2: null,
    endDate2: null,
    alpha: null,
    loc1Draft1: null,
    loc1Draft2: null,
    loc1Loa1: null,
    loc1Loa2: null,
    loc1Dwt1: null,
    loc1Dwt2: null,
    loc1NotesForSTS: null,
    loc2Draft1: null,
    loc2Draft2: null,
    loc2Loa1: null,
    loc2Loa2: null,
    loc2Dwt1: null,
    loc2Dwt2: null,
    loc2NotesForSTS: null,
    additionalInformation: null,
    id: null,
  });

  const handleIncotermOpenModalNew = (_deliveryid = null) => {
    setDeliveryIncotermFormData({
      quantityDeliveryTermId: deliveryformData.id,
      incotermId: null,
      incotermPortType: null,
      incotermRouteId: null,
      incotermLocationId: null,
      incotermLocation2Id: null,
      timelineType: null,
      startDate: null,
      endDate: null,
      timelineType2: null,
      startDate2: null,
      endDate2: null,
      alpha: null,
      loc1Draft1: null,
      loc1Draft2: null,
      loc1Loa1: null,
      loc1Loa2: null,
      loc1Dwt1: null,
      loc1Dwt2: null,
      loc1NotesForSTS: null,
      loc2Draft1: null,
      loc2Draft2: null,
      loc2Loa1: null,
      loc2Loa2: null,
      loc2Dwt1: null,
      loc2Dwt2: null,
      loc2NotesForSTS: null,
      additionalInformation: null,
      id: null,
    });
    togglemodalincoterm();
  };

  const selectedFieldsDeliveryIncotermFormData = {
    quantityDeliveryTermId: deliveryformData.id,
    incotermId: deliveryincotermformData?.incotermId ?? null,
    incotermPortType: deliveryincotermformData?.incotermPortType ?? null,
    incotermRouteId: deliveryincotermformData?.incotermRouteId ?? null,
    incotermLocationId: deliveryincotermformData?.incotermLocationId ?? null,
    incotermLocation2Id: deliveryincotermformData?.incotermLocation2Id ?? null,
    timelineType: deliveryincotermformData?.timelineType ?? null,
    startDate:
      convertToInputDateFormat(deliveryincotermformData?.startDate) ?? null,
    endDate:
      convertToInputDateFormat(deliveryincotermformData?.endDate) ?? null,
    timelineType2: deliveryincotermformData?.timelineType2 ?? null,
    startDate2:
      convertToInputDateFormat(deliveryincotermformData?.startDate2) ?? null,
    endDate2:
      convertToInputDateFormat(deliveryincotermformData?.endDate2) ?? null,
    alpha: deliveryincotermformData?.alpha ?? null,
    loc1Draft1: deliveryincotermformData?.loc1Draft1 ?? null,
    loc1Draft2: deliveryincotermformData?.loc1Draft2 ?? null,
    loc1Loa1: deliveryincotermformData?.loc1Loa1 ?? null,
    loc1Loa2: deliveryincotermformData?.loc1Loa2 ?? null,
    loc1Dwt1: deliveryincotermformData?.loc1Dwt1 ?? null,
    loc1Dwt2: deliveryincotermformData?.loc1Dwt2 ?? null,
    loc1NotesForSTS: deliveryincotermformData?.loc1NotesForSTS ?? null,
    loc2Draft1: deliveryincotermformData?.loc2Draft1 ?? null,
    loc2Draft2: deliveryincotermformData?.loc2Draft2 ?? null,
    loc2Loa1: deliveryincotermformData?.loc2Loa1 ?? null,
    loc2Loa2: deliveryincotermformData?.loc2Loa2 ?? null,
    loc2Dwt1: deliveryincotermformData?.loc2Dwt1 ?? null,
    loc2Dwt2: deliveryincotermformData?.loc2Dwt2 ?? null,
    loc2NotesForSTS: deliveryincotermformData?.loc2NotesForSTS ?? null,
    additionalInformation:
      deliveryincotermformData?.additionalInformation ?? null,
  };

  const handleAddDataDeliveryIncoterm = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(
        `${api.API_URL}/quantity-incoterm`,
        selectedFieldsDeliveryIncotermFormData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //fetchDeliveryDataDetail(response.id);
      //toast.success(`Data has been Saved`);

      fetchDataDeliveryIncoterm(response.id);
      //quantityTableRef.current?.refresh(deliveryformData.id);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      handleSaveDraftProc(); // tetap jalan
      LoadDefault();
    }
  };

  const handleUpdDataDeliveryIncoterm = async () => {
    try {
      setIsLoading(true);

      await axios.put(
        `${api.API_URL}/quantity-incoterm/${deliveryincotermformData.id}`,
        selectedFieldsDeliveryIncotermFormData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data Has been Updated`);

      fetchDataDeliveryIncoterm(deliveryincotermformData.id);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      handleSaveDraftProc();
      LoadDefault();
    }
  };

  const fetchDataDeliveryIncoterm = async Id => {
    try {
      const response = await axios.get(
        `${api.API_URL}/quantity-incoterm/${Id}`,
        {
          withXSRFToken: true,
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: `application/json`,
          },
        }
      );
      const data = response; // ✅ akses nested .data
      if (!data) {
        logger.warn('Data tidak ditemukan dari API');
        return null;
      }
      setDeliveryIncotermFormData({
        quantityDeliveryTermId: data.quantityDeliveryTermId || null,
        incotermId: data.incotermId || null,
        incotermPortType: data.incotermPortType || null,
        incotermRouteId: data.incotermRouteId || null,
        incotermLocationId: data.incotermLocationId || null,
        incotermLocationName: data.incotermLocation?.name || null,
        incotermLocation2Name: data.incotermLocation2?.name || null,
        incotermLocation2Id: data.incotermLocation2Id || null,
        timelineType: data.timelineType || null,
        startDate: convertDisplayddMMyyyy(data.startDate) || null,
        endDate: convertDisplayddMMyyyy(data.endDate) || null,
        timelineType2: data.timelineType2 || null,
        startDate2: convertDisplayddMMyyyy(data.startDate2) || null,
        endDate2: convertDisplayddMMyyyy(data.endDate2) || null,
        alpha: data.alpha || null,
        loc1Draft1: data.loc1Draft1 || null,
        loc1Draft2: data.loc1Draft2 || null,
        loc1Loa1: data.loc1Loa1 || null,
        loc1Loa2: data.loc1Loa2 || null,
        loc1Dwt1: data.loc1Dwt1 || null,
        loc1Dwt2: data.loc1Dwt2 || null,
        loc1NotesForSTS: data.loc1NotesForSTS || null,
        loc2Draft1: data.loc2Draft1 || null,
        loc2Draft2: data.loc2Draft2 || null,
        loc2Loa1: data.loc2Loa1 || null,
        loc2Loa2: data.loc2Loa2 || null,
        loc2Dwt1: data.loc2Dwt1 || null,
        loc2Dwt2: data.loc2Dwt2 || null,
        loc2NotesForSTS: data.loc2NotesForSTS || null,
        additionalInformation: data.additionalInformation || null,
        id: data.id || null,
      });

      return data;
    } catch (error) {
      logger.error('Error fetching data from Invoice API:', error);
      return null;
    }
  };

  const fetchIncotermType = useCallback(async () => {
    try {
      const response = await fetch(`${api.API_URL}/incoterm `, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setIncotremType({ items });
    } catch (error) {
      logger.error('Error index price:', error);
    }
  }, [token]);

  useEffect(() => {
    fetchProductName();
    fetchInvoiceQuantity();
    fetchIncotermRoute();
    fetchIncotermType();
    fetchCurrencyName();
    fetchLaw();
    fetchAbitration();
    setDeliveryFormData(prev => ({
      ...prev,
      procurementId: form.id,
    }));
    setUnitSizeType(
      form.productNameId === '4588b5e6-7309-49d0-9107-59cbb96b6bd8'
        ? 'MT'
        : 'MB'
    );
    setIsEndDate(parseInt(form.contractType, 10) === 2);
  }, [
    form.id,
    form.productNameId,
    form.contractType,
    fetchProductName,
    fetchInvoiceQuantity,
    fetchIncotermRoute,
    fetchIncotermType,
    fetchCurrencyName,
    fetchLaw,
    fetchAbitration,
  ]);

  useEffect(() => {
    if (form.invoicingQuantityId) {
      fetchModeInvoiceQuantity(form.invoicingQuantityId);
    }
  }, [form.invoicingQuantityId, fetchModeInvoiceQuantity]);

  useEffect(() => {
    if (form.productNameId) {
      fetchProductType(form.productNameId);
    }
  }, [form.productNameId, fetchProductType]);

  const handleDelDataDeliveryIncotermDetail = async id => {
    try {
      setIsLoading(true);
      await axios.delete(`${api.API_URL}/quantity-incoterm/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(`Data has been deleted`);
    } catch (error) {
      toast.error(`Failed to delete data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      LoadDefault();
    }
  };

  const handleIncotermOpenModal = async (
    Id = null,
    _IncotermId = null,
    _Section = null
  ) => {
    const data = await fetchDataDeliveryIncoterm(Id);
    if (data && data.incotermId) {
      fetchIncotermLocation(null, data.incotermId);
    }
    togglemodalincoterm();
  };

  const clauses = [...(dataCause.items ?? [])]
    .filter(clause => clause.isShow === true)
    .sort((a, b) => (a.ordreNumber ?? 0) - (b.ordreNumber ?? 0));

  const periodProps = getContractPeriodProps(form);

  //----

  return (
    <React.Fragment>
      <Row>
        <div>
          {form.invitationEvaluationStatus === true && (
            <Card className='border shadow-md mb-4'>
              <CardBody>
                <Row>
                  <Col xs={12}>
                    <div className='mb-2'>
                      <h5 className='fw-bold text-dark mb-1'>
                        Confirmation Detail
                      </h5>
                      <p className='text-muted small'>
                        Bisa Jadi Kalimat tambahan untuk membantu section
                        mengenai apa ini.
                      </p>
                    </div>

                    <Row className='g-4 mb-3'>
                      <Col lg={3}>
                        <div className='mb-2 field-border-brown'>
                          <Label for='contractType' className='text-muted'>
                            Type Confirmation :
                          </Label>
                          <p className='text-dark fs-13 mb-0 lh-base'>
                            {form?.isDelegate || '-'}
                          </p>
                        </div>
                      </Col>

                      <Col lg={3}>
                        <div className='mb-2 field-border-brown'>
                          <Label for='contractType' className='text-muted'>
                            Name :
                          </Label>
                          <p className='text-dark fs-13 mb-0 lh-base'>
                            {' '}
                            {form?.invitationDelegateName || '-'}
                          </p>
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div className='mb-2 field-border-brown'>
                          <Label for='contractType' className='text-muted'>
                            Email :
                          </Label>
                          <p className='text-dark fs-13 mb-0 lh-base'>
                            {' '}
                            {form?.invitationDelegateEmail || '-'}
                          </p>
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div className='mb-2 field-border-brown'>
                          <Label for='contractType' className='text-muted'>
                            Job Title :
                          </Label>
                          <p className='text-dark fs-13 mb-0 lh-base'>
                            {' '}
                            {form?.invitationDelegateJobTitle || '-'}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          )}

          <Card className='border shadow-md mb-4'>
            <CardBody>
              <Row>
                <Col xs={12}>
                  <div className='mb-2'>
                    <h5 className='fw-bold text-dark mb-1'>
                      Invitation Detail
                    </h5>
                    <p className='text-muted small'>
                      Bisa Jadi Kalimat tambahan untuk membantu section mengenai
                      apa ini.
                    </p>
                  </div>

                  <Row className='g-4 mb-3'>
                    <Col lg={4}>
                      <div className='mb-2 field-border-brown'>
                        <Label for='contractType' className='text-muted'>
                          Hari, tanggal
                        </Label>
                        <p className='text-dark fs-13 mb-0 lh-base'>
                          {formatDateToDDMMYYYY(form?.invitationEventDate)}
                        </p>
                      </div>
                    </Col>

                    <Col lg={4}>
                      <div className='mb-2 field-border-brown'>
                        <Label for='contractType' className='text-muted'>
                          Waktu
                        </Label>
                        <p className='text-dark fs-13 mb-0 lh-base'>
                          {form?.invitationStartTime || '-'} -{' '}
                          {form?.invitationTillEnd
                            ? 'Hingga selesai'
                            : form?.invitationEndTime || '-'}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  <Row className='g-4 mb-3'>
                    <Col md={4}>
                      <div className='mb-2 field-border-brown'>
                        <Label for='contractType' className='text-muted'>
                          Location
                        </Label>
                        <p className='text-dark fs-13 mb-0 lh-base'>
                          {form?.invitationLocation || '-'}
                        </p>
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className='mb-2 field-border-brown'>
                        <Label for='contractType' className='text-muted'>
                          Agenda
                        </Label>
                        <p className='text-dark fs-13 mb-0 lh-base'>
                          {form?.invitationAgenda || '-'}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card className='border shadow-sm'>
            <CardBody>
              <Row>
                <Col sm={12}>
                  <div
                    color='dark'
                    className='d-flex align-items-center mb-2  '
                  >
                    <div className='flex-grow-1'>
                      <h5 className='mb-1'>Procurement Information</h5>
                      <p className='text-muted mb-2 fs-12 '>
                        Bisa jadi Kalimat tambahan untuk membantu section
                        mengenai apa ini
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractType' className='text-muted'>
                      Procurement Type :
                    </Label>
                    <p className='form-label mb-2 fs-13 '>
                      {form?.procurementTypeHeaderLabel || '-'}
                    </p>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractType' className='text-muted'>
                      Title Procurement :
                    </Label>
                    <p className='form-label mb-2 fs-13 '>
                      {form?.titleProcurement}
                    </p>
                  </div>
                </Col>
                <Col lg={4}>
                  {!isendDate && (
                    <div className='mb-2 field-border-brown'>
                      <Label for='contractPeriodTermEnd' className='text-muted'>
                        {' '}
                        Proc Type{' :'}
                      </Label>

                      <p className='form-label mb-3 fs-12 '>
                        {form.procurementType}
                      </p>
                    </div>
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card className='border shadow-sm'>
            <CardBody>
              <Row>
                <Col sm={12}>
                  <div
                    color='dark'
                    className='d-flex align-items-center mb-2  '
                  >
                    <div className='flex-grow-1'>
                      <h5 className='mb-1'>Requirement</h5>
                    </div>
                  </div>
                </Col>
                <Col sm={12}>
                  <div color='dark' className='d-flex align-items-center  '>
                    <div className='flex-grow-1'>
                      <h5 className='mb-1'>Contract</h5>
                      <p className='text-muted mb-2 fs-12 '>
                        Bisa jadi Kalimat tambahan untuk membantu section
                        mengenai apa ini
                      </p>
                    </div>
                  </div>
                  <Row className='g-3'>
                    <InfoBlock
                      label='Contract Type'
                      value={getContractTypeLabel(form?.contractType)}
                    />
                    <InfoBlock
                      label={periodProps.startLabel}
                      value={periodProps.startValue}
                      col={3}
                    />
                    {periodProps.endLabel && (
                      <InfoBlock
                        label={periodProps.endLabel}
                        value={periodProps.endValue}
                        col={3}
                      />
                    )}
                    <InfoBlock
                      label='Procurement No'
                      value={form?.procurementNumber}
                      col={3}
                    />
                  </Row>
                </Col>
                <Col sm={12}>
                  <div
                    color='dark'
                    className='d-flex align-items-center  mt-3  '
                  >
                    <div className='flex-grow-1'>
                      <h5 className='mb-1'>Product Specification / Quantity</h5>
                      <p className='text-muted mb-2 fs-12 '>
                        Bisa jadi Kalimat tambahan untuk membantu section
                        mengenai apa ini
                      </p>
                    </div>
                  </div>
                </Col>
                <InfoBlock
                  label='Product Name'
                  value={
                    productName.items?.find(
                      obj => obj.value === form.productNameId
                    )?.label
                  }
                />
                <InfoBlock
                  label='Product Type'
                  value={
                    productTypeData.items?.find(
                      obj => obj.value === form.productTypeId
                    )?.label
                  }
                />
                <InfoBlock
                  label='Operational Tolerance'
                  value={
                    form?.operationalTolerance
                      ? `${form.operationalTolerance}%`
                      : null
                  }
                />
                <InfoBlock
                  label='Operation Tolerance Options'
                  value={form?.partyType}
                />
                <InfoBlock
                  label='Product Specification'
                  value={form?.productSpecification}
                  col={12}
                  isHtml
                />
                <Col sm={12}>
                  <div
                    color='dark'
                    className='d-flex align-items-center  mt-3 '
                  >
                    <div className='flex-grow-1'>
                      <h5 className='mb-1'>Quantity & Delivery Time</h5>
                      <p className='text-muted mb-2 fs-12 '>
                        Bisa jadi Kalimat tambahan untuk membantu section
                        mengenai apa ini
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xl={12}>
                  <div className='mb-1'>
                    {isLoading ? (
                      <Col lg={12} className='text-center'>
                        <div className='text-center'>
                          <div
                            className='spinner-border spinner-border-sm'
                            role='status'
                          >
                            <span className='visually-hidden'>Loading...</span>
                          </div>
                        </div>
                      </Col>
                    ) : error ? (
                      <Col lg={12} className='text-center'>
                        <div className='text-center'>
                          <div className='alert alert-danger'>{error}</div>
                        </div>
                      </Col>
                    ) : (
                      <>
                        {qtyDeliveryData.items.length > 0 ? (
                          qtyDeliveryData.items.map((data, index) => (
                            <Col sm={12} key={`${data.id}-${index}`}>
                              <Col lg={12}>
                                <div
                                  className='d-flex align-items-center mb-1'
                                  style={{
                                    borderTopColor: '#b0b8b2',
                                    borderTopWidth: '1px',
                                    borderTopStyle: 'solid',
                                  }}
                                ></div>
                              </Col>
                              <Col xxl={12}>
                                <Nav tabs className='nav nav-tabs  mb-2'>
                                  <NavItem>
                                    <NavLink
                                      style={{ cursor: 'pointer' }}
                                      className={classnames({
                                        active:
                                          activeTabs[data.id] === `${data.id}1`,
                                      })}
                                      onClick={() =>
                                        toggle(data.id, `${data.id}1`)
                                      }
                                    >
                                      <label className='text-uppercase'>
                                        {' '}
                                        Quantity Delivery Time
                                      </label>
                                    </NavLink>
                                  </NavItem>

                                  <NavItem>
                                    <NavLink
                                      style={{ cursor: 'pointer' }}
                                      className={classnames({
                                        active:
                                          activeTabs[data.id] === `${data.id}2`,
                                      })}
                                      onClick={() =>
                                        toggle(data.id, `${data.id}2`)
                                      }
                                    >
                                      <label className='text-uppercase'>
                                        {' '}
                                        Pricing
                                      </label>
                                    </NavLink>
                                  </NavItem>
                                </Nav>

                                <TabContent activeTab={activeTabs[data.id]}>
                                  <TabPane tabId={`${data.id}1`} id='home'>
                                    <Row>
                                      <Col sm={3}>
                                        <Row>
                                          <Col lg={12}>
                                            <div className=' mt-2  field-border-brown'>
                                              <Label className='text-muted'>
                                                Delivery Unit :
                                              </Label>
                                              <p className='form-label fw-semibold fs-12 '>
                                                {data.deliveryUnit || '-'}
                                              </p>
                                            </div>
                                          </Col>
                                          <Col lg={12}>
                                            <div className=' mt-2  field-border-brown'>
                                              <Label
                                                for='frequencyreadonly'
                                                className='text-muted'
                                              >
                                                Frequency :
                                              </Label>
                                              <p className='form-label fw-semibold fs-12 '>
                                                {data.frequency || '-'}
                                              </p>
                                            </div>
                                          </Col>
                                        </Row>
                                      </Col>

                                      <QuantityTableFragment
                                        ref={quantityRefs.current[index]}
                                        incoTermTable={incoTermTable}
                                        dataid={data.id}
                                        token={token}
                                        unitSizeType={unitSizeType}
                                      />

                                      <IncotermTableFragment
                                        dataid={data.id}
                                        token={token}
                                      />
                                    </Row>
                                  </TabPane>

                                  <TabPane tabId={`${data.id}2`} id='product'>
                                    <Col sm={12}>
                                      <Row>
                                        <Col sm={5}>
                                          <Row>
                                            <Col sm={6}>
                                              <div className=' mt-2  field-border-brown'>
                                                <Label className='text-muted'>
                                                  Delivery Unit :
                                                </Label>
                                                <p className='form-label fw-semibold fs-12 '>
                                                  {data.deliveryUnit || '-'}
                                                </p>
                                              </div>
                                            </Col>

                                            <Col sm={6}>
                                              <div className=' mt-2  field-border-brown'>
                                                <Label className='text-muted'>
                                                  Pricing Period :
                                                </Label>
                                                <p className='form-label fw-semibold fs-12 '>
                                                  {data.pricingPeriod || '-'}
                                                </p>
                                              </div>
                                            </Col>

                                            <Col sm={6}>
                                              <div className=' mt-2  field-border-brown'>
                                                <Label className='text-muted'>
                                                  Index Price Reference :
                                                </Label>
                                                <p className='form-label fw-semibold fs-12 '>
                                                  {data.indexPricename || '-'}
                                                </p>
                                              </div>
                                            </Col>

                                            <Col sm={6}>
                                              <div className=' mt-2  field-border-brown'>
                                                <Label className='text-muted'>
                                                  Other Index Price :
                                                </Label>
                                                <p className='form-label fw-semibold fs-12 '>
                                                  {data.otherIndexPricename ||
                                                    '-'}
                                                </p>
                                              </div>
                                            </Col>

                                            <Col sm={12}>
                                              <div className='mb-2 mt-2'>
                                                <Label
                                                  className='form-check-label'
                                                  for='inlineCheckbox8'
                                                >
                                                  Correlation between two index
                                                  whicever to lower
                                                </Label>
                                              </div>
                                            </Col>

                                            <Col sm={4}>
                                              <div className='mb-2 mt-2  field-border-brown'>
                                                <Label className='text-muted'>
                                                  Publish Index Period :
                                                </Label>
                                                <p className='form-label mb-2 fs-12 '>
                                                  {formatDateToDDMMYYYY(
                                                    data.startDatePublishIndex
                                                  ) || '-'}
                                                </p>
                                              </div>
                                            </Col>

                                            <Col sm={4}>
                                              <div className='mb-2 mt-2  '>
                                                <Label className='text-muted'>
                                                  {''}
                                                </Label>
                                                <p className='form-label mb-2 fs-12 '>
                                                  {formatDateToDDMMYYYY(
                                                    data.endDatePublishIndex
                                                  ) || '-'}
                                                </p>
                                              </div>
                                            </Col>

                                            <Col sm={4}>
                                              <div className='mb-2 mt-2  field-border-brown'>
                                                <Label className='text-muted'>
                                                  Schema B/L Date :
                                                </Label>
                                                <p className='form-label mb-2 fs-12 '>
                                                  {data.schemaBL || '-'}
                                                </p>
                                              </div>
                                            </Col>
                                          </Row>
                                        </Col>

                                        <Col sm={7}>
                                          <Label
                                            for='product-name-3'
                                            className='form-label '
                                          >
                                            Notes for Pricing
                                          </Label>
                                          <div className='snow-editor '>
                                            <EditorProvider>
                                              <Editor
                                                id='notesForPricingRO'
                                                name='notesForPricingRO'
                                                value={
                                                  data.notesForPricing || ''
                                                }
                                                readOnly
                                                style={{
                                                  height: '165px',
                                                  overflowY: 'auto',
                                                }}
                                              ></Editor>
                                            </EditorProvider>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </TabPane>
                                </TabContent>
                              </Col>
                            </Col>
                          ))
                        ) : (
                          <Col lg={12} className='text-center'>
                            <h5 className='fs-15'>No data available</h5>
                          </Col>
                        )}
                      </>
                    )}

                    <Row>
                      <Col sm={12}>
                        <div
                          style={{
                            borderTopColor: '#b0b8b2',
                            borderTopWidth: '1px',
                            borderTopStyle: 'solid',
                          }}
                        ></div>
                        <Card>
                          <div className='mb-1  '>
                            <Label
                              for='additionalNotes'
                              className='form-label  text-uppercase fw-semibold'
                            >
                              Notes
                            </Label>

                            <p className='text-muted mb-2 fs-12 '>
                              Additional notes for this procurement.
                            </p>
                          </div>
                          <div className='snow-editor '>
                            <EditorProvider>
                              <Editor
                                ref={editorRef}
                                id='globalNotes'
                                name='globalNotes'
                                value={form.globalNotes || ''}
                                readOnly
                                style={{ height: '200px', overflowY: 'auto' }}
                                className='form-control bg-light border-0'
                              ></Editor>
                            </EditorProvider>
                          </div>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card className='border shadow-sm'>
            <CardBody>
              <Row>
                <Col sm={12}>
                  <div
                    color='dark'
                    className='d-flex align-items-center mb-2  '
                  >
                    <div className='flex-grow-1'>
                      <h5 className='mb-1'>Clausa Details</h5>
                      <p className='text-muted mb-2 fs-12 '>
                        Bisa jadi Kalimat tambahan untuk membantu section
                        mengenai apa ini
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={12}>
                  {clauses.length > 0 ? (
                    <div className='d-flex flex-column'>
                      {clauses.map((clause, index) => (
                        <ClauseBlock
                          key={clause.id}
                          index={index + 1}
                          title={clause.clauseTitle}
                          value={clause.clauseDescription}
                          isMandatory={clause.isShowToDMUT === true}
                        />
                      ))}
                    </div>
                  ) : (
                    <div className='text-center py-4 text-muted border rounded-3 bg-light-subtle'>
                      No clause data available.
                    </div>
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card className='border shadow-md mb-4'>
            <CardBody>
              <Row>
                <Col xs={12}>
                  <div className='mb-4'>
                    <h5 className='fw-bold text-dark mb-1'>Payment Terms</h5>
                    <p className='text-muted small'>
                      Bisa jadi Kalimat tambahan untuk membantu section mengenai
                      apa ini
                    </p>

                    <Row className='g-3'>
                      <InfoBlock
                        label='Invoicing Quantity'
                        value={
                          invoiceQuantityData.items?.find(
                            obj => obj.value === form.invoicingQuantityId
                          )?.label
                        }
                      />
                      <InfoBlock
                        label='Mode'
                        value={
                          modelinvoiceQuantityData.items?.find(
                            obj => obj.value === form.modeInvoicingQuantityId
                          )?.label
                        }
                      />
                      <InfoBlock
                        label='Currency'
                        value={
                          currencyName.items?.find(
                            obj => obj.value === form.paymentCurrencyId
                          )?.label
                        }
                      />
                      <Col xs={12}>
                        <div className='mb-2 field-border-brown'>
                          <Label for='contractType' className='text-muted'>
                            Description of Payment Term :
                          </Label>
                          <p className='form-label mb-2 fs-13 '>
                            <HtmlContent
                              value={form?.descriptionOfPaymentTerms}
                            />
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>

                <hr className='my-4 border-secondary border-dashed' />

                <Col xs={12}>
                  <div className='mb-4'>
                    <h5 className='fw-bold text-dark mb-1'>Compliance</h5>
                    <p className='text-muted small'>
                      Bisa jadi Kalimat tambahan untuk membantu section mengenai
                      apa ini
                    </p>

                    <Row className='g-3'>
                      <InfoBlock
                        label='Law'
                        value={
                          lawData.items?.find(obj => obj.value === form.lawId)
                            ?.label
                        }
                        col={6}
                      />
                      <InfoBlock
                        label='Arbitration'
                        value={
                          abitrationData.items?.find(
                            obj => obj.value === form.arbitrationId
                          )?.label
                        }
                        col={6}
                      />
                      <Col xs={12}>
                        <div className='mb-2 field-border-brown'>
                          <Label for='contractType' className='text-muted'>
                            Other Terms & Condition :
                          </Label>
                          <p className='form-label mb-2 fs-13 '>
                            <HtmlContent value={form?.otherTermsAndCondition} />
                          </p>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className='mb-2 field-border-brown'>
                          <Label for='contractType' className='text-muted'>
                            Additional Notes :
                          </Label>
                          <p className='form-label mb-2 fs-13 '>
                            <HtmlContent value={form?.additionalNotes} />
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card className='border shadow-md mb-4'>
            <CardBody>
              <Row>
                <Col xs={12}>
                  <div>
                    <h5 className='fw-bold text-dark mb-1'>Validity</h5>
                    <p className='text-muted small'>
                      Bisa jadi Kalimat tambahan untuk membantu section mengenai
                      apa ini
                    </p>

                    <Row className='g-3'>
                      <InfoBlock
                        label='Submission Deadline (Jakarta Local Time)'
                        value={formatProposalDeadline(
                          form?.proposalSubmissionDeadline
                        )}
                        col={6}
                      />
                      <InfoBlock
                        label='Validity Period (Jakarta Local Time)'
                        value={formatProposalDeadline(
                          form?.proposalValidityPeriodMax
                        )}
                        col={6}
                      />
                    </Row>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </Row>
    </React.Fragment>
  );
};

export default RequirementTab;
